/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as EditSvg } from '../../../resources/images/edit.svg';

/* Styles */
import styles from "./styles";


const UpdateCitiPcanModal = ({showEditPcanModal, setShowEditPcaModal, entityPCAN, companyEntityId, setEntityField, entityPCANLimit}) => {

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.updateCitiPcanModal}
      showModal={ showEditPcanModal }
      setShowModal={ setShowEditPcaModal }
      modalIcon={ <EditSvg /> }
      modalTitle={ <FormattedMessage id="editCitiPcanModal.title" /> }
      modalContent={
        <Content
          setShowModal={ setShowEditPcaModal }
          entityPCAN={entityPCAN}
          companyEntityId={companyEntityId}
          setEntityField={setEntityField}
          entityPCANLimit={entityPCANLimit}
        /> }
      dataTestId="updateCitiPcanModal"
    />
  )
}

export default UpdateCitiPcanModal;